import { NavPage } from '@/components/breadcrumbs/Breadcrumbs';
import { CataloguePageHeader } from '@/components/catalogue/Header';
import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import SiChevronLeft from '@/icons/SiChevronLeft';
import { useGeneralStockLevels } from '@/services/catalogue/stockLevels/useGeneralStockLevels';
import {
  useSaveAdditionalGeneralStockLevel,
  useSetAdditionalGeneralStockLevel
} from '@/services/catalogue/useCustomerCatalogueService';
import { useNavigateAndValidate } from '@/services/catalogue/validation/catalogueHooks';
import { useCustomerRoutePrefix } from '@/services/customer/useCustomerRoutePrefix';
import { FunctionComponent } from 'react';
import { CustomerCatalogueContainer } from '../../CustomerCatalogueContainer';
import { StockLevelsTable } from './StockLevelsTable';
import StockUserGuideButton from './StockUserGuideButton';
import { StockTableData } from './stockLevel.types';

const GeneralStockLevelsContent: FunctionComponent = () => {
  const routePrefix = useCustomerRoutePrefix();
  const navigateAndValidate = useNavigateAndValidate();

  const breadcrumbs: NavPage[] = [
    {
      name: 'Stock Calculator',
      to: `${routePrefix}/stockCalculator`
    },
    {
      name: 'Additional Stock Levels',
      to: ''
    }
  ];

  const stockLevels = useGeneralStockLevels();

  const set = useSetAdditionalGeneralStockLevel();
  const save = useSaveAdditionalGeneralStockLevel();

  const onSave = async (data: StockTableData[]) => {
    if (!data) return;

    data.forEach(row => {
      set(row.productId, row.minStockLevel, row.maxStockLevel);
    });

    await save(data.map(row => row.productId));
  };

  return (
    <div className="flex h-full flex-1 flex-col bg-white bg-opacity-50">
      <CataloguePageHeader title={'Stock Calculator'} subtitle="Additional Stock Levels" breadcrumbs={breadcrumbs}>
        <div className="flex gap-4">
          <StockUserGuideButton />
          <Button
            onClick={() => {
              navigateAndValidate(`${routePrefix}/advanced/bundleStockLevels`);
            }}
            variant={ButtonVariant.Mono}
          >
            <SiChevronLeft className="text-xl" />
            <span>Back to Bundle Stock Levels</span>
          </Button>
          <Button
            onClick={() => {
              navigateAndValidate(`${routePrefix}/advanced/summaryStockLevels`);
            }}
            variant={ButtonVariant.Primary}
          >
            <span>Review Summary</span>
          </Button>
        </div>
      </CataloguePageHeader>
      <div className="overflow-y-auto px-6 py-8 space-y-5 flex-1">
        {stockLevels.length === 0 ? (
          <div>There are no selected standardised products to display.</div>
        ) : (
          <StockLevelsTable stockLevels={stockLevels} onSaveCallback={onSave} />
        )}
      </div>
    </div>
  );
};

export const GeneralStockLevels: FunctionComponent = () => {
  return (
    <CustomerCatalogueContainer>
      <GeneralStockLevelsContent />
    </CustomerCatalogueContainer>
  );
};
